import { ref } from "vue";

// Глобальное состояние лоадера
const isLoading = ref(false);
const loadingText = ref("");

export function useGlobalLoader() {
  const showLoader = (text?: string) => {
    loadingText.value = text || "";
    isLoading.value = true;
  };

  const hideLoader = () => {
    isLoading.value = false;
    loadingText.value = "";
  };

  return {
    isLoading,
    loadingText,
    showLoader,
    hideLoader,
  };
}
